import { cairnReferenceFromHash } from "../helpers/cairnHash.js";

const reference = cairnReferenceFromHash(globalThis.location.hash);

if (reference !== undefined && reference.length > 0) {
	globalThis.location.replace("/trip" + globalThis.location.search + globalThis.location.hash);
}
